import { ClientDetailScreenContent } from "../../features/clientDetail";

// ClientDetailScreen — route landing for /clients/:clientId (Phase R2).
// Mounts under MainLayout. Thin composition wrapper around the feature
// widget. No selectors, no dispatch, no state — all owned by the
// widget.
//
// Phase S1: the static "Клієнт" header was removed because the
// data-driven cd-header inside ClientDetailScreenContent (name, pills,
// meta, actions) is the page's true header. Removing the duplicate
// avoids two stacked H1s and matches design/clientDetail.html.

function ClientDetailScreen() {
  return (
    <section
      className="client-detail-page"
      id="Csection"
      tabIndex="-1"
    >
      <div className="container">
        <ClientDetailScreenContent />
      </div>
    </section>
  );
}

export default ClientDetailScreen;
